import { withValidator } from '../../validation/withValidator.js';
export const getValidation = (field, validator, required = false) => required ? withValidator(field, validator) : field;
//# sourceMappingURL=getValidation.js.map